module.exports = __webpack_public_path__ + "2d9611622c460622c23cac6cedd00237.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/northwestern_university_2_2023_chart.png
// module id = 1706
// module chunks = 0